import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import Table from "react-bootstrap/Table";
import AxisSpinner from "./AxisSpinner";
import { BsDownload, BsCalendarCheck } from "react-icons/bs";
import { Row, Col, Container, Button, Card, Form, InputGroup, Alert } from "react-bootstrap";
import AuditReportModal from "../modals/AuditReportModal";
import { format } from "date-fns";

const MissedAvailabilityReportTable = () => {
  const { authAxios } = useAuth();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showReport, setShowReport] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    setLoading(true);
    try {
      const response = await authAxios().get("/api/backoffice/reporting/missed_availability");
      setReports(response.data || []);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching missed availability reports:", err);
      setReports([]);
      setLoading(false);
    }
  };

  const handleRowClick = (report) => {
    setSelectedReport(report);
    setShowReport(true);
  };

  const handleModalClose = () => {
    setShowReport(false);
    setSelectedReport(null);
  };


  return (
    <>
      <Container fluid>
        <Card className="mb-4">
          <Card.Header>
            <Row className="align-items-center">
              <Col>
                <h5 className="mb-0">
                  <BsCalendarCheck className="me-2" />
                  Missed Availability Reports
                </h5>
              </Col>
              <Col xs="auto">
                <Button variant="outline-primary" size="sm" onClick={() => fetchReports()}>
                  Refresh
                </Button>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <Row className="mb-3">
              <Col>
                <small className="text-muted">
                  {reports.length} report{reports.length !== 1 ? "s" : ""} found
                </small>
              </Col>
            </Row>

            {loading ? (
              <div className="text-center py-5">
                <AxisSpinner loading={loading} />
              </div>
            ) : reports.length === 0 ? (
              <Alert variant="info">
                No reports are available.
              </Alert>
            ) : (
              <div className="table-responsive">
                <Table hover striped className="mb-0">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Last Modified</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reports.map((report, index) => (
                      <tr
                        key={index}
                        onClick={() => handleRowClick(report)}
                        style={{ cursor: "pointer" }}
                      >
                        <td>
                          {report.reportDate
                            ? format(new Date(report.reportDate), "yyyy-MM-dd")
                            : "Unknown"}
                        </td>
                        <td>
                          {report.lastModified
                            ? format(new Date(report.lastModified), "yyyy-MM-dd HH:mm:ss")
                            : "Unknown"}
                        </td>
                        <td className="text-center">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRowClick(report);
                            }}
                          >
                            <BsDownload className="me-1" /> View
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>

      {showReport && selectedReport && (
        <AuditReportModal
          show={showReport}
          report={{
            reports: [selectedReport.filename],
            month: selectedReport.reportDate,
          }}
          modalName="Missed Availability Report"
          actionType="missed_availability_file"
          close={handleModalClose}
        />
      )}
    </>
  );
};

export default MissedAvailabilityReportTable;